import HyperLink from "src/components/atoms/hyper-link/hyper-link";
import Banner from "src/components/molecules/banner/Banner";
import CreateCampaign from "./create-campaign";
import { useState } from "react";
import CampaignList from "./campaign-list";

const CampaignMain = () => {
	const [showCreateCampaign, setCreateCampaign] = useState(false);
	const [showCampaignList, setShowCampaignList] = useState(true);

	const toggleShowCreateCampaign = () => {
		setCreateCampaign((prevValue) => !prevValue);
		setShowCampaignList(false);
	};

	const toggleShowCampaignList = () => {
		setShowCampaignList((prevValue) => !prevValue);
		setCreateCampaign(false);
	};

	return (
		<>
			<Banner label={"Branding Campaigns"}>
				<div className="bg-white p-6 rounded-lg drop-shadow-2xl">
					<div className="flex flex-col items-start justify-center gap-12">
						<div className="flex items-center justify-start gap-4">
							<HyperLink
								href={"#"}
								label={"Create campaign"}
								onClick={() => toggleShowCreateCampaign()}
							></HyperLink>
							<HyperLink
								href={"#"}
								label={"Create recurring campaign"}
								onClick={() => setCreateCampaign(true)}
							></HyperLink>
							<HyperLink
								href={"#"}
								label={"View campaign"}
							></HyperLink>
							<HyperLink
								href={"#"}
								label={"Download template"}
							></HyperLink>
						</div>
						{showCampaignList && <CampaignList></CampaignList>}
						{showCreateCampaign && (
							<CreateCampaign
								onClose={toggleShowCreateCampaign}
							></CreateCampaign>
						)}
					</div>
				</div>
			</Banner>
		</>
	);
};

export default CampaignMain;
